import './styles/nav-buttons.css'
import WhiteBorderBtn from './UI/WhiteBorderBtn'
import BlueBtn from './UI/BlueBtn'

export default function NavButtons({type}) {

  if(type === 'faq'){
    return (
      <div className='nav__buttons faq-nav-btns'>
        <button className='nav-faq__white-btn'>Sign in</button>
        <BlueBtn text={'Get started'} width={'139'}/>
      </div>
    )
  }

  return (
    <div className='nav__buttons'>
        <WhiteBorderBtn/>
        <button className='nav__button-started'>Get started</button>
    </div>
  )
}
